import React from 'react'
import classnames from 'classnames'
import styles from './Tooltip.module.css'

export interface TooltipProps {
  label: string
  placement?: 'top' | 'bottom'
  /** Alignement horizontal par rapport au déclencheur (défaut : centré). */
  align?: 'start' | 'center' | 'end'
  /** Autorise le retour à la ligne : à utiliser pour les messages d'explication. */
  multiline?: boolean
  className?: string
  children: React.ReactElement
}

const Tooltip: React.FC<TooltipProps> = ({
  label,
  placement = 'top',
  align = 'center',
  multiline = false,
  className,
  children
}) => {
  return (
    <span className={classnames(styles.wrapper, className)}>
      {children}
      <span
        className={classnames(
          styles.tooltip,
          styles[placement],
          {
            [styles.multiline]: multiline,
            [styles.start]: align === 'start',
            [styles.end]: align === 'end'
          }
        )}
        role="tooltip"
      >
        {label}
      </span>
    </span>
  )
}

export default Tooltip
